<div class="cat-modal">
    <div class="cat-modal__header">
        <h3>{{ 'category_modal_title' | translate }}</h3>
        <button type="button" class="cat-modal__close" (click)="activeModal.dismiss()" [attr.aria-label]="'admin_action_close' | translate">&times;</button>
    </div>

    <form class="cat-modal__body" (ngSubmit)="save()">
        <label class="field">
            <span>{{ 'category_modal_name' | translate }}</span>
            <input ngbAutofocus type="text" name="categoryName" [(ngModel)]="categoryName" autocomplete="off" required />
        </label>
        <button type="submit" class="cat-modal__submit" [disabled]="!categoryName.trim()">{{ 'admin_action_save' | translate }}</button>
    </form>
</div>
